import React from 'react';
import './Card.css'; // Import the styling for the card
import img11 from './banner.jpg';
import img12 from './log.jpg';
import img13 from './lol.jpg';
import Lang from '../Lang/Lang';

const ImageContainer: React.FC = () => {
    // Define an array of imported image URLs
    const imageUrls = [img13, img11]; // Add more image imports as needed

    const renderImages = () => {
        let images = [];
        for (let i = 0; i < imageUrls.length; i += 2) {
            // Render two images in a row
            images.push(
                <div key={i} className="image-row">
                    <img
                        src={imageUrls[i]}
                        alt={`Image ${i + 1}`}
                        className="circular-image"
                        id={`image${i + 1}`}
                    />
                    {i + 1 < imageUrls.length && (
                        <img
                            src={imageUrls[i + 1]}
                            alt={`Image ${i + 2}`}
                            className="circular-image2"
                            id={`image${i + 2}`}
                        />
                    )}
                </div>
            );
        }
        return images;
    };

    return <div className="container">{renderImages()}</div>;
};

export default ImageContainer;
